export default "__VITE_ASSET__DOgTRJbb__"